{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} konverzací vybráno",
    "AGENT_SELECT_LABEL": "Vybrat agenta",
    "ASSIGN_CONFIRMATION_LABEL": "Opravdu chcete přiřadit {conversationCount} {conversationLabel} uživateli",
    "UNASSIGN_CONFIRMATION_LABEL": "Opravdu chcete zrušit přiřazení {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Zpět",
    "ASSIGN_LABEL": "Přiřadit",
    "YES": "Ano",
    "SEARCH_INPUT_PLACEHOLDER": "Hledat",
    "ASSIGN_AGENT_TOOLTIP": "Přiřadit agenta",
    "ASSIGN_TEAM_TOOLTIP": "Přiřadit tým",
    "ASSIGN_SUCCESFUL": "Konverzace byly úspěšně přiřazeny.",
    "ASSIGN_FAILED": "Nepodařilo se přiřadit konverzace. Zkuste to prosím znovu.",
    "RESOLVE_SUCCESFUL": "Konverzace byly úspěšně vyřešeny.",
    "RESOLVE_FAILED": "Nepodařilo se vyřešit konverzace. Zkuste to prosím znovu.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Jsou vybrány pouze konverzace viditelné na této stránce.",
    "AGENT_LIST_LOADING": "Načítání agentů",
    "UPDATE": {
      "CHANGE_STATUS": "Změnit stav",
      "SNOOZE_UNTIL": "Odložit",
      "UPDATE_SUCCESFUL": "Stav konverzace byl úspěšně aktualizován.",
      "UPDATE_FAILED": "Nepodařilo se aktualizovat konverzace. Zkuste to prosím znovu."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Přiřadit štítky",
      "NO_LABELS_FOUND": "Nebyly nalezeny žádné štítky pro",
      "ASSIGN_SELECTED_LABELS": "Přiřadit vybrané štítky",
      "ASSIGN_SUCCESFUL": "Štítky byly úspěšně přiřazeny.",
      "ASSIGN_FAILED": "Přiřazení štítků se nezdařilo. Zkuste to prosím znovu."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Vybrat tým",
      "NONE": "Žádný",
      "NO_TEAMS_AVAILABLE": "K tomuto účtu zatím nejsou přidány žádné týmy.",
      "ASSIGN_SELECTED_TEAMS": "Přiřadit vybraný tým.",
      "ASSIGN_SUCCESFUL": "Týmy byly úspěšně přiřazeny.",
      "ASSIGN_FAILED": "Nepodařilo se přiřadit tým. Zkuste to prosím znovu."
    },
    "MERGE": {
      "TOOLTIP": "Sloučit konverzace",
      "TITLE": "Sloučit konverzace",
      "DESCRIPTION": "Vyberte cílovou konverzaci. Všechny ostatní vybrané konverzace budou do ní sloučeny — jejich zprávy budou přesunuty do cílové a zdrojové konverzace budou smazány.",
      "TARGET_LABEL": "Cílová konverzace (bude zachována)",
      "SOURCES_LABEL": "Zdrojové konverzace (budou smazány)",
      "SELECT_TARGET": "Vyberte konverzaci jako cíl sloučení",
      "WARNING": "Varování: Tuto akci nelze vrátit zpět. Zprávy ze všech zdrojových konverzací budou přesunuty do cílové konverzace a zdrojové konverzace budou trvale smazány.",
      "SUBMIT": "Sloučit konverzace",
      "CANCEL": "Zrušit",
      "SUCCESS_MESSAGE": "Konverzace byly úspěšně sloučeny",
      "ERROR_MESSAGE": "Nepodařilo se sloučit konverzace. Zkuste to prosím znovu.",
      "CONFIRM": {
        "TITLE": "Potvrdit sloučení",
        "DESCRIPTION": "Opravdu chcete sloučit {sourceCount} konverzací do #{targetId}? Tuto akci nelze vrátit zpět.",
        "YES": "Ano, sloučit",
        "CANCEL": "Zrušit"
      }
    }
  }
}